
import { logger } from '@/utils/logger';
import { FAQResponse } from '@/components/faq-serp/types';

/**
 * Log the result of the FAQ generation process for monitoring
 */
export function logFaqGenerationResult(response: FAQResponse): void {
  try {
    // Count the total number of FAQs
    const totalFaqs = Object.values(response.faq).reduce(
      (count, items) => count + items.length, 
      0
    );
    
    // Calculate the average length of answers
    let totalAnswerLength = 0;
    let answerCount = 0;
    
    Object.values(response.faq).forEach(items => {
      items.forEach(item => {
        const answerLength = 
          item.answer.intro.length + 
          item.answer.conclusion.length +
          item.answer.details.reduce((sum, detail) => sum + detail.length, 0);
        
        totalAnswerLength += answerLength;
        answerCount += 1;
      });
    });
    
    const avgAnswerLength = answerCount > 0 ? totalAnswerLength / answerCount : 0;
    
    // Log the successful generation with statistics
    logger.info('FAQ generation statistics', {
      component: 'faqExpertService',
      context: {
        totalFaqs,
        beginnerFaqs: response.faq.beginner.length,
        intermediateFaqs: response.faq.intermediate.length,
        expertFaqs: response.faq.expert.length,
        companyFaqs: response.faq.company.length,
        avgAnswerLength: Math.round(avgAnswerLength)
      }
    });
  } catch (error) {
    // If there's any error in logging, don't fail the process
    logger.warn('Error logging FAQ generation statistics', {
      component: 'faqExpertService',
      context: {
        error: (error as Error).message
      }
    });
  }
}
